import React, { useState } from "react";

import { themes } from "../database";

type Theme = {
  bg: string;
  heading: string;
  accent: string;
  text: string;
  primary: string;
};

const Theme: React.FC = () => {
  const [style, setStyle] = useState<string>("theme-popup");
  const [menuStatus, setMenuStatus] = useState<boolean>(true);
  const ThemeSvg = require("../assets/icons/theme.svg").default;

  const handleClick = () => {
    switch (menuStatus) {
      case true:
        setMenuStatus(false);
        setStyle("theme-popup theme-active");
        break;
      case false:
        setMenuStatus(true);
        setStyle("theme-popup");
        break;
      default:
      // do nothing
    }
  };

  const changeTheme = ({ bg, heading, accent, text, primary }: Theme) => {
    document.documentElement.style.setProperty("--color-bg", bg);
    document.documentElement.style.setProperty("--color-heading", heading);
    document.documentElement.style.setProperty("--color-accent", accent);
    document.documentElement.style.setProperty("--color-text", text);
    document.documentElement.style.setProperty("--color-primary", primary);
  };

  return (
    <div className="theme">
      <div className={style}>
        <p className="bold theme-title">Select Theme</p>
        <div className="theme-container">
          {themes.map(({ name, bg, heading, accent, text, primary }) => (
            <div
              className="theme-cards"
              style={{
                backgroundColor: bg,
                borderColor: accent,
                color: text,
              }}
              key={name}
              onClick={() =>
                changeTheme({ bg, heading, accent, text, primary })
              }
            >
              <p>{name}</p>
              <div className="color-dots">
                <span
                  className="color-dot"
                  style={{ backgroundColor: primary }}
                ></span>
                <span
                  className="color-dot"
                  style={{ backgroundColor: text }}
                ></span>
                <span
                  className="color-dot"
                  style={{ backgroundColor: bg }}
                ></span>
                <span
                  className="color-dot"
                  style={{ backgroundColor: heading }}
                ></span>
                <span
                  className="color-dot"
                  style={{ backgroundColor: accent }}
                ></span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="nav-link-theme">
        <button onClick={handleClick}>
          <img src={ThemeSvg} className="btn-svg" />
        </button>
      </div>
    </div>
  );
};

export default Theme;
